import React from "react";
import { observer } from "mobx-react";
import _ from "lodash";

import "./DockedList.scss";
import { SidebarContext } from "../Sidebar";

export default observer(function DockedList({
  search,
  query,
  children,
  className = "",
  title,
  searchControls,
}) {
  const sidebarStore = React.useContext(SidebarContext);
  const ref = React.useRef();
  React.useLayoutEffect(() => {
    sidebarStore.width = ref.current.clientWidth;
  }, []);
  return (
    <div
      className={`${className} docked-list component`}
      ref={ref}
      style={{ flexBasis: sidebarStore.width }}
    >
      {title && <div className="title">{title}</div>}
      <div className="search">
        {searchControls || <SearchFeild {...{ query, search }} />}
      </div>
      {children}
    </div>
  );
});

export const SearchFeild = ({ query, search }) => {
  const onChange = React.useMemo(() =>
    _.debounce((e) => {
      Object.assign(e.target, search(e.target.value.trim()));
    }, 200),
  );
  return (
    <input
      className="search-field"
      type="search"
      placeholder="Search"
      onChange={onChange}
      defaultValue={query}
    />
  );
};
